import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ServiceRestServices from '../../services/service-rest.service';
import Config from '../../utils/config.service';
import DialogServices from '../../services/dialog.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';
import { ModalAddTherapyFundWalletComponent } from '../modal-add-therapy-fund-wallet/modal-add-therapy-fund-wallet.component';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Subscription, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	standalone: true,
	selector: 'table-therapy-fund-wallets',
	templateUrl: './table-therapy-fund-wallets.component.html',
	imports: [
		CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe, 
		TranslatePipe, ItemNoContentComponent, LoaderOverlayComponent, FormsModule
	]
})
export class TableTherapyFundWalletsComponent implements OnInit, OnDestroy {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private config: Config = inject(Config);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	@Input() wallets: any;
	@Output() walletsChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() currentPage: any | undefined;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	searchSubject: Subject<string> = new Subject<string>();
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
		
		this.searchSubject.pipe(
			debounceTime(500)
		).subscribe(searchTerm => {
			this.loadWallets(true);
		});
	}
	
	ngOnInit() {
		this.vm.filter = {
			orderBy: 'created',
			ascending: false
		};
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.endReached = false;
		this.vm.loading = true;
		this.loadWallets(true, true);
		
		this.vm.setFilter = this.setFilter;
		this.vm.loadWallets = this.loadWallets;
		this.vm.deactivate = this.deactivate;
		this.vm.addWallet = this.addWallet;

		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, "loadMorePages", () => {
				if (!this.vm.endReached) {
					this.loadWallets();
				}
			})
		);
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	onSearchChange(searchTerm: string) {
		this.searchSubject.next(searchTerm);
	}
	
	loadWallets(isInitial?, hasLoader?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		var params: any = {
			pageSize: this.vm.pageSize * 2,
			start: (!isInitial && this.vm.wallets) ? this.vm.wallets.length : 0,
			orderBy: this.vm.filter.orderBy || 'created',
			ascending: this.vm.filter.ascending || false
		};
		if (this.vm.term && this.vm.term.trim() && this.vm.term.trim().length > 2) params.name = this.vm.term.trim();
		this.handleDownloadUrlUpdate();
		
		this.serviceRestServices.getTherapyFundWallets(params, (wallets) => {
			if (wallets && wallets.length < this.vm.pageSize * 2) {
				this.vm.endReached = true;
			}
			if (isInitial) this.vm.currentPage = 0;
			if (hasLoader) {
				this.angularHelperService.createTimer(() => {
					this.vm.loading = false;
					this.vm.wallets = isInitial ? wallets : this.vm.wallets.concat(wallets);
					this.walletsChange.emit(this.vm.wallets);
				}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
			} else {
				this.vm.wallets = isInitial ? wallets : this.vm.wallets.concat(wallets);
				this.walletsChange.emit(this.vm.wallets);
			}
		});
	}
	
	addWallet() {
		var dialog = this.dialogServices.show({
			controller: ModalAddTherapyFundWalletComponent,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
		dialog.afterClosed().subscribe((response) => {
			console.log("Adding completed.");
			this.loadWallets(true);
		}, (error) => {
			console.log(error);
		});
	}
	
	deactivate(wallet) {
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('TherapyFundWallet.Deactivate_Confirmation'),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.serviceRestServices.deactivateTherapyFundWallet({ walletId: wallet.id }, () => {
					wallet.active = false;
					console.log("Deactivation successful.");
				});
			}
		});
	}
	
	setFilter(name) {
		this.vm.filter = this.vm.filter || {};
		this.vm.filter.ascending = this.vm.filter.orderBy === name ? !this.vm.filter.ascending : false;
		this.vm.filter.orderBy = name;
		
		this.loadWallets(true);
	}
	
	handleDownloadUrlUpdate() {
		var url: any = this.config.getRestUrl() + 'rest/therapy/fund/wallet/wallet-report.csv';
		var params: Array<any> = [];
		params.push("orderBy=" + (this.vm.filter.orderBy ? this.vm.filter.orderBy : "created"));
		params.push("ascending=" + (this.vm.filter.ascending ? this.vm.filter.ascending : false));
		if (this.vm.term && this.vm.term.trim() && this.vm.term.trim().length > 2) params.push("name=" + this.vm.term.trim());
		
		this.vm.csvDownloadUrl = url + (params.length ? '?' + params.join('&') : '');
	}
	
}